import React from 'react';
import { Order, OrderItem } from '../../../../../hooks/useOrder';
import { AccountOrderActionPay, AccountOrderActionTrack } from '../../../../AccountOrderActions';

enum AccountOrderActionCategory {
  Open = 'open',
  Shipped = 'shipped',
  Returned = 'returned'
}

interface Props {
  categoryName: AccountOrderActionCategory | string;
  orderNumber: string;
  order: Order;
  orderItems: OrderItem[];
}

export const AccountOrderBodyActions: React.FC<Props> = ({
  categoryName,
  orderNumber,
  order,
  orderItems
}) => {
  switch (categoryName) {
    case AccountOrderActionCategory.Open:
      return order && orderNumber ? (
        <AccountOrderActionPay order={order} orderNumber={orderNumber} />
      ) : null;
    case AccountOrderActionCategory.Shipped:
      return orderItems && orderNumber ? (
        <AccountOrderActionTrack orderItems={orderItems} orderNumber={orderNumber} />
      ) : null;
    default:
      return null;
  }
};
